import React from "react";
import PropTypes from "prop-types";
import statuses from "utils/static/statuses";

const Status = ({ id, withIcon }) => {
    const status = statuses[id];
    const label = status?.label || id;
    const category = status?.category || "default";

    return (
        <div className={`status status--${category}`}>
            {withIcon && status?.Icon}
            <span className="status__label">{label}</span>
        </div>
    );
};

Status.propTypes = {
    id: PropTypes.string.isRequired,
    withIcon: PropTypes.bool,
};

Status.defaultProps = {
    withIcon: false,
};

export default Status;
